import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { ICustomDotsStyles } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultDots/styled';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const customDotsStyles: ICustomDotsStyles = {
    dot: {
        background: COLORS.GRAY_S,
        opacity: 1,
    },
    activeDot: {
        background: COLORS.GRAY_M,
    },
};

export const Wrapper = styled.div`
    width: 100%;
`;

export const LesionItem = styled.div`
    padding: 4px;
    background-color: ${COLORS.white};
    border-radius: 16px;
    overflow: hidden;
`;

export const ImageWrap = styled.div<{ icon: string }>`
    position: relative;

    &:after {
        display: inline-block;
        position: absolute;
        top: 24px;
        left: 26px;
        content: "";
        background-image: url('${p => p.icon}');
        background-repeat: no-repeat;
        width: 56px;
        height: 56px;
    }
`;

export const Picture = styled.picture`
    width: 100%;
`;

export const Image = styled.img`
    width: 100%;
    object-fit: contain;
    height: auto;
`;

export const Title = styled.div`
    min-height: 64px;
    ${FONTS.H3};
    color: ${COLORS.GRAY_DARK};
    white-space: break-spaces;
    margin: 14px 0 18px 18px;
`;
